import {ofType} from 'redux-observable';
import {map, switchMap} from 'rxjs/operators';
import {ActionCreator, buildCatchError, createReducer} from '../../store/utils';

import {getPolygonApi} from './api';

export type PolygonAction = Action & {
  id?: string,
  address?: string,
  error?: string,
};

export type FetchGeometryRequest = {
  provider: string,
  place_id: string,
  location: string,
};

export type PolygonType = {
  id?: string,
  address?: string,
  path?: any[],
};

export type CityType = {
  enabled?: boolean,
  id: string,
  location: string,
  polygons: any[],
};

export type PolygonsState = {
  isFetchingGeometry?: boolean,
  fetchGeometryError?: boolean,
  fetchGeometrySuccess?: boolean,
  preview?: {[key: string]: any},
};

export class FetchGeometry extends ActionCreator<PolygonAction> {}
export class FetchGeometrySuccess extends ActionCreator<PolygonAction> {}
export class FetchGeometryErrorFn extends ActionCreator<PolygonAction> {}

export class RemovePreviewGeometry extends ActionCreator<PolygonAction> {}

export class ResetStatePolygons extends ActionCreator<PolygonAction> {}

export const actions = {
  fetchGeometry: (payload: PolygonAction) => new FetchGeometry(payload),
  removePreview: () => new RemovePreviewGeometry(),
  resetStatePolygons: () => new ResetStatePolygons(),
  //   updateActiveLocation: () => new UpdateActiveLocation(),
  //   setActiveLocation: (payload: PolygonAction) => new SetActiveLocation(payload),
};

export const initialState: PolygonsState = {};

export default createReducer(initialState, {
  [FetchGeometry.type]: state => ({
    ...state,
    isFetchingGeometry: true,
    fetchGeometryError: undefined,
    fetchGeometrySuccess: undefined,
    preview: undefined,
  }),
  [FetchGeometrySuccess.type]: (state, action: PolygonAction) => {
    const {id, location, polygons} = action;
    return {
      ...state,
      isFetchingGeometry: false,
      fetchGeometryError: undefined,
      fetchGeometrySuccess: true,
      preview: {id, location, polygons, enabled: true},
    };
  },
  [FetchGeometryErrorFn.type]: (state, action: PolygonAction) => ({
    ...state,
    isFetchingGeometry: undefined,
    fetchGeometryError: action.error,
  }),
  [RemovePreviewGeometry.type]: state => ({
    ...state,
    preview: undefined,
  }),
  [ResetStatePolygons.type]: state => initialState,
  //   [SetActiveLocation.type]: (state, action: PolygonAction) => {
  //     const activeLocation = state.polygons.find(loc => loc.id === action.id);
  //     return {
  //       ...state,
  //       activeLocation: activeLocation ? activeLocation : {id: action.id},
  //     };
  //   },
  //   [UpdateActiveLocation.type]: state => ({
  //     ...state,
  //     polygons: [
  //       ...state.polygons,
  //       {id: state.activeLocation.id, ...state.preview},
  //     ],
  //     activeLocation: undefined,
  //   }),
});

export function fetchGeometryEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(FetchGeometry.type),
    switchMap((fetchGeometryRequest: FetchGeometryRequest) => {
      const {place_id, provider, location} = fetchGeometryRequest;
      return getPolygonApi({place_id, provider}).pipe(
        map(
          polygons =>
            new FetchGeometrySuccess({id: place_id, location, polygons})
        ),
        buildCatchError(FetchGeometryErrorFn)
      );
    })
  );
}
